import ContentSubmitDialog from 'components/Dialog/ContentSubmitDialog';
import { tokenSelector } from 'features/auth/authSlice';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editParentAsync, editParentReqSelector } from '../slices/adminSlice';
import Button from 'components/CustomButtons/Button';
import ParentInputs from './ParentInputs';
import { RootState } from 'features';

interface Props {
  parentId: string;
  initialName: string;
  initialEmail: string;
  initialPassword: string;
  initialPhone: string;
  initialStudents: Types.API.User.IUserInfo[];
}
const EditParent: React.FC<Props> = ({
  parentId,
  initialEmail,
  initialName,
  initialPassword,
  initialPhone,
  initialStudents,
}) => {
  const dispatch = useDispatch();
  const token = useSelector(tokenSelector);
  const [name, setName] = React.useState(initialName);
  const [email, setEmail] = React.useState(initialEmail);
  const [password, setPassword] = React.useState(initialPassword);
  const [phone, setPhone] = React.useState(initialPhone);
  const [parentStudents, setParentStudents] = React.useState(initialStudents);
  const [open, setOpen] = React.useState(false);
  const students = useSelector((state: RootState) => state.admin.students);

  const createReq = useSelector(editParentReqSelector);
  const handleClose = () => setOpen(false);
  const handleOpen = () => {
    setName(initialName);
    setEmail(initialEmail);
    setPassword(initialPassword);
    setPhone(initialPhone);
    setParentStudents(initialStudents);
    setOpen(true);
  };
  const handleParentEditSubmit = () => {
    dispatch(
      editParentAsync({
        token,
        parent: { name, email, password, phone, studentsIds: parentStudents.map(s => s.id) },
        id: parentId,
      }),
    );
  };
  return (
    <div>
      <Button onClick={handleOpen}>Edit Selected Parent</Button>
      <ContentSubmitDialog
        open={open}
        dialogTitle="Edit Parent"
        onClose={handleClose}
        onSubmitClick={handleParentEditSubmit}
        asyncSubmitReq={{
          status: createReq.status,
          errorMessage: createReq.error || 'Cannot edit the parent',
          loadingMessage: 'Editing the parent',
          successMessage: 'Successfully Edited the parent',
        }}
      >
        <ParentInputs
          name={name}
          onNameChange={e => setName(e.target.value)}
          password={password}
          onPasswordChange={e => setPassword(e.target.value)}
          email={email}
          onEmailChange={e => setEmail(e.target.value)}
          phone={phone}
          onPhoneChange={e => setPhone(e.target.value)}
          onStudentsChange={s => {
            setParentStudents(s);
          }}
          students={students}
          parentStudents={parentStudents}
        />
      </ContentSubmitDialog>
    </div>
  );
};

export default EditParent;
